import React, { type FC } from 'react';

import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack } from '@atlaskit/primitives/stack';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { GeneratingStreamAnimation } from '../../common/assets/GeneratingStreamAnimation';

const BoxStyles = xcss({
	color: 'color.text.subtlest',
	backgroundColor: 'elevation.surface.sunken',
	padding: 'space.150',
	borderRadius: 'radius.large',
	borderBottomLeftRadius: 'radius.small',
});

const i18n = defineMessages({
	generatingSummaryText: {
		id: 'ai-summary-loading.title',
		defaultMessage: 'Writing a summary',
		description: 'Text for loading state of ai summary streaming',
	},
	generatingSummaryAnimationAlt: {
		id: 'ai-stream-loading.generation-animation',
		defaultMessage: 'Generating',
		description: 'Alt text of the generation animation',
	},
});

export const AISummaryLoading: FC = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={BoxStyles}>
			<Stack space="space.100">
				<FormattedMessage {...i18n.generatingSummaryText} />
				<GeneratingStreamAnimation alt={formatMessage(i18n.generatingSummaryAnimationAlt)} />
			</Stack>
		</Box>
	);
};
